// Shared theme/config for margin rail marker types

import CommentIcon from '@mui/icons-material/Comment';
import LinkIcon from '@mui/icons-material/Link';
import CheckIcon from '@mui/icons-material/Check';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import EditNoteIcon from '@mui/icons-material/EditNote';

export const markerTheme = {
    comment: {
        type: 'comment',
        label: 'Comment',
        Icon: CommentIcon,
        color: '#fbbc04',
        bg: 'rgba(251, 188, 4, 0.16)',
        border: 'rgba(251, 188, 4, 0.55)',
    },
    reference: {
        type: 'reference',
        label: 'Reference',
        Icon: LinkIcon,
        color: '#1a73e8',
        bg: 'rgba(26, 115, 232, 0.14)',
        border: 'rgba(26,115,232,0.55)',
    },
    task: {
        type: 'task',
        label: 'Task',
        Icon: CheckIcon,
        color: '#a142f4',
        bg: 'rgba(161, 66, 244, 0.14)',
        border: 'rgba(161,66,244,0.55)',
    },
    insertion: {
        type: 'insertion',
        label: 'Suggested addition',
        Icon: AddCircleOutlineIcon,
        color: '#1e8e3e',
        bg: 'rgba(30, 142, 62, 0.12)',
        border: 'rgba(30,142,62,0.45)',
    },
    deletion: {
        type: 'deletion',
        label: 'Suggested deletion',
        Icon: RemoveCircleOutlineIcon,
        color: '#d93025',
        bg: 'rgba(217, 48, 37, 0.10)',
        border: 'rgba(217,48,37,0.45)',
    },
    change: {
        type: 'change',
        label: 'Suggested change',
        Icon: EditNoteIcon,
        color: '#e37400',
        bg: 'rgba(227, 116, 0, 0.10)',
        border: 'rgba(227,116,0,0.45)',
    },
};

export function getMarkerTheme(type) {
    return markerTheme[type] || {
        type,
        label: type,
        Icon: null,
        color: '#5f6368',
        bg: 'rgba(60,64,67,0.06)',
        border: 'rgba(60,64,67,0.20)',
    };
}

